module.exports = require('./coinSelections/index');
